document.addEventListener('DOMContentLoaded', function() {
  /**
   * Extensão AdjustableHeight para Splide
   * Recebe as opções:
   *  - adjustableHeight.whileSliding (boolean)
   *  - adjustableHeight.speed (string, ex: '0.4s')
   */
  function AdjustableHeight( Splide, Components, options ) {
    const track = Components.Elements.track;
    const list  = Components.Elements.list;

    // defaults
    const settings = {
      whileSliding: options.adjustableHeight?.whileSliding ?? true,
      speed:         options.adjustableHeight?.speed         ?? '0.4s',
    };

    function mount() {
      // escolhe os eventos conforme whileSliding
      const eventType = settings.whileSliding
        ? 'move active resize'
        : 'active resized';

      // ajusta a altura sempre que forem disparados
      Splide.on( eventType, (_e, newIndex) => adjustHeight(newIndex) );

      // ajuste inicial
      adjustHeight( Splide.index );
    }

    function adjustHeight( newIndex ) {
      // determina o slide atual
      const idx   = typeof newIndex === 'number' ? newIndex : Splide.index;
      const slide = Components.Slides.getAt(idx).slide;

      const slideHeight = slide.offsetHeight;

      // se ajustar o track, soma o padding dele
      let totalHeight = slideHeight;
      if (settings.whileSliding) {
        const style = window.getComputedStyle(track);
        const padTop  = parseInt(style.paddingTop);
        const padBot  = parseInt(style.paddingBottom);
        totalHeight  += padTop + padBot;
      }

      // garante flex-start
      list.style.alignItems = 'flex-start';

      // aplica transição e altura
      const element = settings.whileSliding ? track : list;
      element.style.transition = 'height ' + settings.speed;
      element.style.height     = totalHeight + 'px';
    }

    return { mount };
  }

  // seu init original, agora com adjustableHeight
  document.querySelectorAll('.js-testimonials-slider').forEach(slider => {
    const splide = new Splide(slider, {
      type:        'loop',
      perPage:     1,
      autoplay:    false,
      interval:    6000,
      pagination:  true,
      arrows:      false,
      // configurações da extensão
      adjustableHeight: {
        whileSliding: true,
        speed:         '0.4s',
      },
    });

    // monta com a extensão
    splide.mount({ AdjustableHeight });
  });
});